<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'article/index' }">
                                Berita
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Berita
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="col-auto">
                <router-link v-bind:to="{ name: 'article/add' }" class="btn btn-danger btn-sm font-weight-medium mt-4 mb-2">
                    Create New Berita +
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 section" v-for="article in articles" v-bind:key="article.id">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <router-link v-bind:to="{name: 'article/view', params: {id: article.id}}" class="h4 font-weight-medium text-white mb-0">
                                    Berita {{ [article.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("dddd, D MMMM YYYY") }}
                                </router-link>
                            </div>
                            <div class="col-auto">
                                <router-link v-bind:to="{name: 'article/edit', params: {id: article.id}}" class="btn btn-link h4 p-0 my-0 mr-2">
                                    Edit
                                </router-link>
                                <button class="btn btn-link h4 p-0 my-0" v-on:click="modal = true; reference = article">
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="text-muted">
                            Banner Berita:
                        </div>
                        <img v-bind:src="article.imageUrl" class="img-fluid mb-2 rounded w-100" />
                        <div class="text-muted">
                            Judul Banner:
                        </div>
                        <router-link v-bind:to="{name: 'article/view', params: {id: article.id}}" class="card-text font-weight-bold text-dark d-block mb-2">
                            {{ article.title }}
                        </router-link>
                        <div class="text-muted">
                            Kalimat Pembuka:
                        </div> 
                        <p class="card-text">
                            {{ article.foreword }}
                        </p>
                        <div class="text-muted">
                            Isi Berita:
                        </div>
                        <div v-html="article.content" class="summary mb-4" style="overflow: hidden; max-height: 7rem;"></div>
                        <router-link v-bind:to="{ name: 'article/view', params: { id: article.id } }" class="position-absolute mb-4" style="bottom: 0;">
                            Selengkapnya
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>

        <b-modal v-model="modal" v-on:hide="reference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus berita ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';

    export default {
        name: "ArticleIndex",
        components: {
            Paginate
        },
        data() {
            return {
                form: {
                    keyword: ''
                },
                articles: [{}, {}, {}, {}, {}],
                pageCount: 0,
                page: 1,
                modal: false,
                reference: null
            };
        },
        methods: {
            remove() {
                if (this.reference) {
                    this.axios.post(process.env.API_URL + '/article/delete/' + this.reference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.paginate(this.page);
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal = false;
                        this.reference = null;
                    });
                }
            },
            paginate(page) {
                this.axios.get(process.env.API_URL + '/article', {params: Object.assign({}, this.form, {page: page})}).then(response => {
                    this.articles = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;
                });
            }
        },
        mounted() {
            this.paginate(1);
            document.title = 'List Berita - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .section .summary { display: block; overflow: hidden; max-height: 7rem; }
</style>


// WEBPACK FOOTER //
// src/components/article/Index.vue